
define(
    'Facets.Browse.View.Extension',
    [
        'Facets.Browse.View',
        'underscore',
        'Utils'
    ],
    function (
        FacetsBrowseView,
        _,
        Utils

    ) {
        'use strict';

        _.extend(FacetsBrowseView.prototype, {

            isQuery: function () {
                return this.model.options && this.model.options.data && this.model.options.data.q
            },

            getCurrentQuery: function () {
                return this.model.options && this.model.options.data && this.model.options.data.q
            },


            mustPrepareNewCategoryFacet: function () {

                var lastQuery = sessionStorage.getItem('last_query');
                var currentQuery = this.getCurrentQuery();

                if (currentQuery == lastQuery) {
                    return false
                } else {

                    sessionStorage.setItem('last_query', currentQuery);
                    return true
                }
            },

            populateSelectedFilters: function () {
                this.turnOffLoader();


                if (this.model.options && this.model.options.data && this.model.options.data.commercecategoryurl) {

                    var cath_path_applied = _.find(this.translator.facets, function (facet) {
                        return facet.id.indexOf("cat_path_") != -1
                    })
                    if (cath_path_applied) {

                        // Add class to checkbox
                        this.$("#" + cath_path_applied.id).prop('checked', true);

                        // Add class to span
                        this.$("#span_" + cath_path_applied.id).addClass("option-active");

                        var standardFacets = this.model.get("facets");

                        var facets = this.getFacetsCategories(standardFacets)

                        var filter = _.filter(facets, function (facet) {
                            return _.find(facet.values, function (value) {
                                return value.htmlId == cath_path_applied.id
                            })
                        });

                        this.$("#collapse_" + filter[0].url).removeClass("collapsed");

                        this.$(".collapse_" + filter[0].url).addClass("in");

                        this.$("#" + cath_path_applied.id + "-level3-wrapper").addClass("in");




                    }

                }

            },

            initialize: _.wrap(FacetsBrowseView.prototype.initialize, function (fn) {

                // this.turnOnLoader();
                var self = this;
                var ret = fn.apply(this, _.toArray(arguments).slice(1));
                
                this.on('afterViewRender', function () {
                    _.defer(_.bind(self.populateSelectedFilters, this));

                }, this);


                return ret;
            }),

          



            turnOnLoader: function () {
                jQuery("#facet-wrapper-loader").show();

            },

            turnOffLoader: function () {
                jQuery("#facet-wrapper-loader").hide();
            },



            beforeShowContent: _.wrap(FacetsBrowseView.prototype.beforeShowContent, function (fn) {

                var options = this.model.options;
                if (options && options.data) {
                    var keys = _.keys(options.data);
                    var existCathPath = _.find(keys, function (key) {
                        return key.indexOf("cat_path_") != -1
                    })

                    if (existCathPath) {
                        var categoryValue = options.data[existCathPath];
                        delete options.data[existCathPath];
                        options.data["commercecategoryurl"] = decodeURIComponent(categoryValue)
                    }
                }
                var ret = fn.apply(this, _.toArray(arguments).slice(1));



                return ret;
            }),

            showContent: _.wrap(FacetsBrowseView.prototype.showContent, function (fn) {
                var ret = fn.apply(this, _.toArray(arguments).slice(1));
                if (this.model.get('category')) {
                    if (this.model.get('category').get('categories').length > 0) {
                        this.totalPages = 1;
                    }
                }
                
                this.model.get('items').models = this.model.get('items').models.reverse()
                return ret
            }),


            getContext: _.wrap(FacetsBrowseView.prototype.getContext, function (fn) {

                var ret = fn.apply(this, _.toArray(arguments).slice(1));
                ret.showResults = this.isQuery() || ret.showResults
               if (this.model.get('category'))  {
                   if (this.model.get('category').get('categories').length > 0) {
                       ret.showItems = false;
                   }
               }
                this.addCategoryFacets()


                return ret;
            }),

            getFirstLevelCategoriesNames: function () {
                return _.map(SC.CATEGORIES, function (primaryCategory) {
                    return primaryCategory.name
                })
            },

            getSecondLevelCategories: function (primaryCategoriesArray, facets) {

                var secondLevelCategoryResult = []

                var commerceCategoryFacet = _.find(facets, function (facet) {
                    return facet.id == "commercecategoryname"
                })

                if (commerceCategoryFacet) {
                    var values = commerceCategoryFacet.values;

                    _.each(primaryCategoriesArray, function (primaryCategoryName) {
                        var primaryCategory = _.find(SC.CATEGORIES, function (primaryCategoryElement) {
                            return primaryCategoryElement.name == primaryCategoryName;
                        })

                        if (primaryCategory) {
                            _.each(primaryCategory.categories, function (secondLevelCategory) {
                                var isSecondLevelActive = _.find(values, function (value) {
                                    return value.url == secondLevelCategory.name
                                })
                                if (isSecondLevelActive)
                                    secondLevelCategoryResult.push(secondLevelCategory.name)
                            })
                        }
                    })

                }

                return secondLevelCategoryResult;

            },



            getThirdLevelCategories: function (primaryCategoriesArray, secondCategoriesArray, facets) {

                var thirdLevelCategoryResult = []

                var commerceCategoryFacet = _.find(facets, function (facet) {
                    return facet.id == "commercecategoryname"
                })

                if (commerceCategoryFacet) {
                    var values = commerceCategoryFacet.values;

                    _.each(primaryCategoriesArray, function (primaryCategoryName) {
                        var primaryCategory = _.find(SC.CATEGORIES, function (primaryCategoryElement) {
                            return primaryCategoryElement.name == primaryCategoryName;
                        })

                        if (primaryCategory) {

                            _.each(primaryCategory.categories, function (secondLevelCategory) {

                                _.each(secondLevelCategory.categories, function (thirdLevelCategory) {

                                    var isThirdLevelActive = _.find(values, function (value) {
                                        return value.url == thirdLevelCategory.name
                                    })
                                    if (isThirdLevelActive)
                                        thirdLevelCategoryResult.push(thirdLevelCategory.name)

                                })

                            })
                        }
                    })

                }

                return thirdLevelCategoryResult;

            },



            /**
             * @method getPrimaryCategories
             * 
             */
            getPrimaryCategories: function (facets) {

                var firstLevelCategoriesResult = []

                var firstLevelCategories = _.map(SC.CATEGORIES, function (primaryCategory) {
                    return primaryCategory.name
                })
                // find the commerce categories facet
                var commerceCategoryFacet = _.find(facets, function (facet) {
                    return facet.id == "commercecategoryname"
                })

                if (commerceCategoryFacet) {
                    var values = commerceCategoryFacet.values;
                    firstLevelCategoriesResult = _.filter(firstLevelCategories, function (firstLevelCatName) {
                        return _.find(values, function (value) {
                            return value.url == firstLevelCatName
                        })
                    })
                }

                return firstLevelCategoriesResult

            },



            getFacetsCategories: function (facets) {


                var primaryCategoriesArray = this.getPrimaryCategories(facets);
                var secondCategoriesArray = this.getSecondLevelCategories(primaryCategoriesArray, facets);
                var thirdCategoriesArray = this.getThirdLevelCategories(primaryCategoriesArray, secondCategoriesArray, facets);


                var fullCategoryTree = SC.CATEGORIES;

                // FILTER 1
                // Return the first level categories that apply for the current query
                var filteredByQueryCategoryTree = _.filter(fullCategoryTree, function (primaryCategory) {
                    return primaryCategoriesArray.indexOf(primaryCategory.name) != -1
                });

                // FILTER 2
                // Then we filter the second level
                _.each(filteredByQueryCategoryTree, function (primaryCategory) {
                    primaryCategory.categories = _.filter(primaryCategory.categories, function (secondLevelCategory) {
                        return secondCategoriesArray.indexOf(secondLevelCategory.name) != -1
                    })
                })

                // FILTER 3
                // Then we filter the third level
                _.each(filteredByQueryCategoryTree, function (primaryCategory) {
                    _.each(primaryCategory.categories, function (secondLevelCategory) {
                        secondLevelCategory.categories = _.filter(secondLevelCategory.categories, function (thirdLevelCategory) {
                            return thirdCategoriesArray.indexOf(thirdLevelCategory.name) != -1
                        })

                    })
                })



                return _.map(filteredByQueryCategoryTree, function (primaryCategory, i) {




                    return {
                        "id": primaryCategory.name,
                        "cat_internalid": primaryCategory.internalid,
                        "htmlId": primaryCategory.internalid,
                        "url": "cat_path_" + primaryCategory.internalid, // Este se usa como titulo para cada elemento, hay que ver config
                        // Second level of categories
                        "values": _.map(primaryCategory.categories, function (categorySubLevel1) {
                            return {
                                "cat_internalid": categorySubLevel1.internalid,
                                "parent": primaryCategory.internalid,
                                "htmlId": "cat_path_" + categorySubLevel1.internalid,
                                "url": categorySubLevel1.fullurl,
                                "label": categorySubLevel1.name,
                                "isCollapsed": true,
                                "thirdlevelcategoriesmenutree": categorySubLevel1.categories.length > 0,

                                "values": _.map(categorySubLevel1.categories, function (categorySubLevel2) {
                                    return {
                                        "cat_internalid": categorySubLevel2.internalid,
                                        "parent": categorySubLevel1.internalid,
                                        "htmlId": "cat_path_" + primaryCategory.internalid,
                                        "url": categorySubLevel2.fullurl,
                                        "label": categorySubLevel2.name,
                                        "isCollapsed": true,
                                        "fourthlevelcategoriesmenutree": categorySubLevel2.categories.length > 0,
                                        "values": _.map(categorySubLevel2.categories, function (categorySubLevel3) {
                                            return {
                                                "cat_internalid": categorySubLevel3.internalid,
                                                "parent": categorySubLevel2.internalid,
                                                "url": categorySubLevel3.fullurl,
                                                "label": categorySubLevel3.name,
                                                "isCollapsed": true,
                                                "htmlId": "cat_path_" + categorySubLevel3.internalid,

                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })




            },

            show4Level: function () {

                var cath_path_applied = _.find(this.translator.facets, function (facet) {
                    return facet.id.indexOf("cat_path_") != -1
                })

                if (cath_path_applied) {
                    if (cath_path_applied.id) {
                        var num = cath_path_applied.id.match(/\d+/)[0].toString()
                    }
                }


                var standardFacets = this.model.get("facets");

                var facets = this.getFacetsCategories(standardFacets)

                var filterGeneral = []

                _.each(facets, function (facet) {
                    var filter = _.filter(facet.values, function (value) {
                        return _.find(value.values, function (val) {
                            return val.cat_internalid == num
                        })
                    });
                    if (filter.length > 0) {
                        filterGeneral.push(filter)
                    }
                });

                if (filterGeneral.length > 0) {
                    var filter = filterGeneral[0][0];

                    var filter2 = _.filter(filter.values, function (value) {
                        return value.cat_internalid == num
                    })

                    $(document).ready(function () {

                        $("#cat_path_" + filter2[0].parent + "-level3-wrapper").addClass("in");

                        $('.collapse_' + filter2[0].htmlId).addClass('in')

                    })

                }

            },
            addCategoryFacets: function () {

                if (this.isQuery()) {

                    console.log("start");
                    var standardFacets = this.model.get("facets");
                    var categoriesFacets = [];
                    if (this.mustPrepareNewCategoryFacet()) {

                        categoriesFacets = this.getFacetsCategories(standardFacets);
                        sessionStorage.setItem('last_categories_facets', JSON.stringify(categoriesFacets));

                    } else {
                        categoriesFacets = JSON.parse(sessionStorage.getItem('last_categories_facets'))
                    }

                    var all_facets = categoriesFacets.concat(standardFacets);

                    this.model.set("facets", all_facets)

                    this.show4Level();
                    console.log("end");

                }
            }
        });
    });
